import MediaRenderer from './MediaRenderer.vue';

export default MediaRenderer;
